import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./abstract.css";

function ExpertsPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>Experts</h3> }
        text_content={<div><ol>
            <li>
            <p class="western" ><strong>Dr. Ramachandra T.V</strong></p>
            
            <p class="western" >Co-ordinator, EWRG, CES, Indian Institute of Science, Bangalore</p>
            <p class="western" >Area of Specialization: Water Quality, Ecology, Ecosystems, Sustainability, Environment, Biodiversity, Wetlands, Pattern Recognition, Biodiversity &amp; Conservation, Land Use Change, Urbanism, Land Use, Aquatic Ecosystems</p>
            <p class="western" >E-mail Id: <a href="mailto:tvr@iisc.ac.in">tvr@iisc.ac.in</a></p>
            <p class="western" >Contact No: 91-080-22933099(D)/22933503 (extn 107)</p>
            <p class="western" ></p></li></ol>
            <ol start="2">
            <li>
            <p class="western" ><strong>Dr. Bharath Setturu</strong></p>
            
            <p class="western" >School of Mathematics &amp; Social Sciences, Chanakya University</p>
            <p class="western" >Area of Specialization: Spatial Informatics, Image Processing, Landscape Modeling, Spatial Decision Support System (SDSS)</p>
            <p class="western" >E-mail Id: <a href="mailto:bharath.settur@gmail.com">bharath.settur@gmail.com</a></p>
            <p class="western" ></p></li></ol>
            <ol start="3">
            <li>
            <p class="western" ><strong>Dr. Bharath H Aithal</strong></p>
            
            <p class="western" >Ranbir and Chitra Gupta School of Infrastructure Design and Management (RCG SIDM)</p>
            <p class="western" >3rd floor, IIT Kharagpur, West Bengal, Pin: 721302, Below Coral. </p>
            <p class="western" >Area of Specialization: Spatial analysis, Geoinformation, Urban Analysis, climate change, Urban sprawl, land use modelling, Machine learning and Deep learning in Geoinformatics</p>
            <p class="western" >Phone: +91 03222304944</p>
            <p class="western" >Email id: <a href="mailto:bharath@infra.iitkgp.ac.in">bharath@infra.iitkgp.ac.in</a></p>
            <p class="western" ></p></li></ol>
            <ol start="4">
            <li>
            <p ><strong>Dr. Anand Inamdar</strong></p>
            
            <p >North Carolina Institute for Climate Studies, North Carolina State University, Raleigh, NC 27695, USA</p>
            <p >Area of Specialization: earth radiation budgets; remote sensing of land surface parameters; surface energy balance from satellites</p>
            <p >Email id:<a href="mailto:anand.inamdar@noaa.gov">anand.inamdar@noaa.gov</a></p>
            <p class="western" ></p></li></ol>
            <ol start="5">
            <li>
            <p ><strong>Dimitris Tsirantonakis</strong></p>
            
            <p >Remote Sensing Lab of FORTH</p>
            <p >Area of Specialization: Urban Environment &amp; Climate Monitoring</p>
           
            <p class="western" ></p></li></ol>
            <ol start="6">
            <li>
            <p ><strong>Dr. Sandeep Pattnaik</strong></p>
            
            <p >School of Earth, Ocean and Climate Sciences</p>
            <p >Area of Specialization: Tropical Meteorology, Cloud Physics, Tropical Cyclone, Extreme events</p>
            <p class="western" ></p></li></ol>
            <ol start="7">
            <li>
            <p ><strong>Dr. Sridhara Nayak</strong></p>
            
            <p >Disaster Prevention Research Institute, Kyoto University, Gokasho, Uji, Kyoto, 611-0011, Japan</p>
            <p >Area of Specialization: Weather forecasting, Extreme weather events, Climate modeling and Land use &amp; Land cover change </p>
            <p class="western" ></p></li></ol>
            <ol start="8">
            <li>
            <p ><strong>Bappa Das</strong></p>
            
            <p >ICAR - Central Coastal Agricultural Research Institute, Old Goa, India</p>
            <p >Area of Specialization: Soil physics, Remote sensing, Agro-meteorology and Hyperspectral remote sensing</p>
            <p >Email id: <a href="mailto:bappa.das@icar.gov.in">bappa.das@icar.gov.in</a></p>
            <p class="western" ></p></li></ol>
            <ol start="9">
            <li>
            <p ><strong>Dr. Seema </strong><strong>Rani</strong></p>
            
            <p >Dept. of Geography,<a href="https://scholar.google.com/citations?view_op=view_org&amp;hl=en&amp;org=2911747152626759782">Banaras Hindu University, Varanasi</a>, UP, India</p>
            <p >Area of Specialization: Climate change and Land surface temperature</p>
            <p class="western" ></p></li></ol>
            <ol start="10">
            <li>
            <p ><strong>Dr Sanju Purohit</strong></p>
            
            <p >Akamai University, USA</p>
            <p >Area of Specialization: Rain water harvesting, Land and water resources management, LULC and Environmental/Ecology </p>
            <p class="western"></p></li></ol>
            <ol start="11">
            <li>
            <p ><strong>Ambadas Bandu Maske</strong></p>
            
            <p >College of Engineering Pune</p>
            <p >Area of Specialization: GIS, Remote sensing, Climate change, Land surface temperature and Sustainability </p></li></ol>
            
            <ol start="12">
            <li>
            <p ><strong>Kukku Sara</strong></p>
            
            <p >Indian Institute of Technology Bombay</p>
            <p >Area of Specialization: Thermal remote sensing, Super resolution, Land surface temperature, Heatwaves and Urban heat island </p>
            </li></ol>
            <ol start="13">
            <li>
            <p ><strong>R K Mall</strong></p>
            
            <p >DST- Mahamana Centre of Excellence in Climate Change, BHU</p>
            <p >Area of Specialization: Climate science, Climate Change impacts, Climate-crop modelling, Climate-health and Environmental science </p>
            <p class="western" ></p></li></ol>
            <ol start="14">
            <li>
            <p ><strong>AK Sahai</strong></p>
            
            <p >Indian Institute of Tropical Meteorology, Pune</p>
            <p >Area of Specialization: monsoon prediction and variability</p>
            <p class="western" ></p></li></ol>
            <ol start="15">
            <li>
            <p ><strong>Dr. Kanhu Charan Pattnayak</strong></p>
            
            <p >University of Leeds, Leeds, United Kingdom </p>
            <p >Area of Specialization: Indian Monsoon, Climate Change, Climate Modelling, Regional Climate Modelling and Amazon Climate</p>
            <p class="western" ></p></li></ol>
            <ol start="16">
            <li>
            <p ><strong>Bikash Ranjan Parida</strong></p>
            
            <p >Department of Geoinformatics,<a href="https://scholar.google.com/citations?view_op=view_org&amp;hl=en&amp;org=2468764577697246037">Central University of Jharkhand</a>, India</p>
            <p >Area of Specialization: Satellite earth observations, Remote sensing, Land atmosphere interaction and Climate change </p>
            <p class="western" ></p></li></ol>
            <ol start="17">
            <li>
            <p ><strong>Dr. Somnath Bar</strong></p>
            
            <p >University of California-Irvine, Department of Civil and Environmental Engineering</p>
            <p >Area of Specialization: Remote sensing and Terrestrial atmosphere interaction</p>
            <p class="western" ></p></li></ol>
            <ol start="18">
            <li>
            <p ><strong>RN Singh</strong></p>
            
            <p >Indian Council of Agricultural research </p>
            <p >Area of Specialization: Agricultural physics, Climate change, Remote sensing and Machine learning </p></li></ol>
            
            <ol start="19">
            <li>
            <p ><strong>Satya Prakash</strong></p>
            
            <p >India Meteorological Department, Ministry of Earth Sciences</p>
            <p >Area of Specialization: Satellite remote sensing, South Asian monsoon rainfall</p>
            <p >NWP model output diagnostic and Global water cycle</p>
            <p class="western"></p></li></ol>
            <ol start="20">
            <li>
            <p ><strong>Hamidreza Norouzi</strong></p>
            
            <p > New York City College of Technology, CUNY</p>
            <p >Area of Specialization: Remote sensing, Earth system, Climate and Environment</p>
            <p class="western" ></p></li></ol>
            <ol start="21">
            <li>
            <p ><strong>Rajeev Bhatla</strong></p>
            
            <p >Department of Geophysics, BHU, Varanasi, India</p>
            <p >Area of Specialization: Climate modeling, Monsoon dynamic and Climate change </p>
            <p class="western" ></p></li></ol>
            <ol start="22">
            <li>
            <p ><strong>Dr. Latief Ahmad</strong></p>
            
            <p >School of Environmental Sciences,<a href="https://scholar.google.com/citations?view_op=view_org&amp;hl=en&amp;org=12406940829042173998">University of Guelph-Canada</a></p>
            <p >Area of Specialization: Crop science, Agrometeorology, Climate change, Satellite farming and Crop simulation modelling </p>
            <p class="western" ></p></li></ol>
            <ol start="23">
            <li>
            <p ><strong>Priyanka </strong><strong>Rao</strong></p>
            
            <p >University of Bologna </p>
            <p >Area of Specialization: Remote sensing and GIS, Time series analysis and change, Urban greenery and UHI, Urban climate and big data analysis </p>
            <p class="western" ></p></li></ol>
            <ol start="24">
            <li>
            <p ><strong>Kshama Gupta</strong></p>
            
            <p ><a href="https://scholar.google.com/citations?view_op=view_org&amp;hl=en&amp;org=15192189743375902108">IIRS</a>, Dehradun</p>
            <p >Area of Specialization: Urban micro climate, Remote sensing, 3D modeling, LiDAR and Urban green spaces </p>
            <p class="western" ></p></li></ol>
            <ol start="25">
            <li>
            <p ><strong>Arijit Roy</strong></p>
            
            <p ><a href="https://scholar.google.com/citations?view_op=view_org&amp;hl=en&amp;org=15192189743375902108">IIRS</a>, Dehradun</p>
            <p >Area of Specialization: Ecology, Ecological modelling, Remote sensing, GIS and Climate change </p>
            </li></ol>
            <ol start="26">
            <li>
            <p ><strong>Dr. Shahfahad</strong></p>
            
            <p >Department of Geography, Institute of Science,<a href="https://scholar.google.com/citations?view_op=view_org&amp;hl=en&amp;org=2911747152626759782">Banaras Hindu University</a></p>
            <p >Area of Specialization: Urban geography, Climate change, Remote sensing &amp; GIS, Thermal environment and Groundwater</p>
            <p class="western" ></p></li></ol>
            <ol start="27">
            <li>
            <p ><strong>Anurag Kandya</strong></p>
            
            <p >Department of Civil Engineering, Pandit Deendayal Energy University</p>
            <p >Area of Specialization: Urban heat islands, Air pollution, Green buildings, Building energy modelling and GIS</p>
            <p class="western" ></p></li></ol>
            <ol start="28">
            <li>
            <p ><strong>Dr. Debadatta Swain</strong></p>
            
            <p >School of Earth, Ocean &amp; Climate Sciences, IIT Bhubaneswar, INDIA</p>
            <p >Area of Specialization: Satellite &amp; physical oceanography, air sea interactions and Urban climate</p>
            <p class="western" ></p></li></ol></div>}
        />

    )
}
export default ExpertsPage;